import React, { useState, Fragment } from "react";
import { useLogin, useNotify, Notification } from "react-admin";
import { AuthDriver as auth } from "auth";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const login = useLogin();
  const notify = useNotify();
  const submit = (e) => {
    e.preventDefault();
    login({ username, password }).catch(() =>
      notify("Invalid username or password")
    );
  };

  if (auth.usesExternalFlow()) {
    auth.attemptLogin();
    return null;
  }

  return (
    <Fragment>
      <form onSubmit={submit}>
        <input
          name="username"
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <input
          name="password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button type="submit" label="submit" className="button">
          Login
        </button>
      </form>
      <Notification />
    </Fragment>
  );
};

export default Login;
